import {
  type UnionAddress,
  getBlockchainFromAddress,
} from "@anaconda/core/blockchain/address"
import { Blockchain } from "@anaconda/core/blockchain/types"

export function filterProfileAvailableBlockchains(
  blockchains: readonly Blockchain[],
  profileWalletAddress: UnionAddress,
  isEvmBlockchain: (blockchain: Blockchain) => boolean,
): Blockchain[] {
  const profileChainGroup = getBlockchainFromAddress(profileWalletAddress)

  if (profileChainGroup === Blockchain.SOLANA) {
    return blockchains.filter((blockchain) => blockchain === Blockchain.SOLANA)
  }

  if (profileChainGroup === Blockchain.ECLIPSE) {
    return blockchains.filter((blockchain) => blockchain === Blockchain.ECLIPSE)
  }

  return blockchains.filter((blockchain) => isEvmBlockchain(blockchain))
}
